// labels.bagason.app — boot: wire the UI modules together.
import { S, subscribe, canUndo, canRedo } from './ui/state.js';
import { $, applyKbdLabels } from './ui/dom.js';
import { initTheme } from './ui/theme.js';
import { initView } from './ui/view.js';
import { initCanvas } from './ui/canvas.js';
import { initInteraction } from './ui/interaction.js';
import { initFieldList } from './ui/fieldList.js';
import { initProps } from './ui/props/index.js';
import { initMenus } from './ui/menus.js';
import { initCmdK } from './ui/cmdk.js';
import { initShortcuts } from './ui/shortcuts.js';
import { initCheck } from './ui/check.js';
import { initIO, renderFileChrome } from './ui/io.js';
import { select } from './ui/state.js';
import { fieldBounds } from './ui/geometry.js';

function renderHistoryChrome() {
  $('#btn-undo').disabled = !canUndo();
  $('#btn-redo').disabled = !canRedo();
}

function boot() {
  initTheme();
  applyKbdLabels();
  initView();
  initCheck();
  initCanvas();
  initInteraction();
  initFieldList();
  initProps();
  initMenus();
  initCmdK();
  initShortcuts();
  initIO();
  subscribe((r) => {
    if (r.has('file') || r.has('history') || r.has('doc')) {
      renderFileChrome();
      renderHistoryChrome();
    }
  });
  renderFileChrome();
  renderHistoryChrome();
  setInterval(renderFileChrome, 15000);
  // Read-only debugging handle (used by the UI verification script).
  Object.defineProperty(window, '__labelsEditor', { value: { state: S, fieldBounds, select }, configurable: true });
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
